/* eslint-disable import/no-unresolved */
import React from 'react';
import { Options } from 'react-lottie';
import checkedAnimation from 'assets/animations/checked_done.json';
import { Container, LottieWrapper } from './styles';

const animationLoopOptions = {
  loop: false,
  goAndStop: true,
  goAndPlay: false,
  isPaused: false,
  autoplay: false,
  isStopped: true,
  animationData: checkedAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const useCallback = (callback: any, values: any) => {
  const self = React.useRef({
    values,
    handler: (...args: any) => {
      return callback(...args, self.current.values);
    },
  });
  self.current.values = values;
  return self.current.handler;
};

interface RadioButtonSelectProps {
  text: string;
  isChecked: boolean;
  toggleSelectContracts: (tipoPagamento: string, updateAll?: boolean) => void;
}

const RadioButtonSelect = (props: RadioButtonSelectProps) => {
  const { isChecked, text, toggleSelectContracts } = props;
  const [animationOptions, setAnimationOptions] = React.useState<Object>(animationLoopOptions);
  const [animationSwap, setAnimationSwap] = React.useState<boolean | null>(true);

  const handleLoopComplete = useCallback(
    (event: any, [...animationSwap]) => {
      if (animationSwap) {
        setAnimationOptions(animationOptions);
        setAnimationSwap(false);
      }
    },
    [animationSwap],
  );
  return (
    <div className="d-inline-flex hover-pointer">
      <Container
        onClick={() => {
          toggleSelectContracts(text, isChecked);
        }}
      >
        <LottieWrapper
          style={{ width: '63px' }}
          isStopped={!isChecked}
          options={animationOptions as Options}
          eventListeners={[
            {
              eventName: 'complete',
              callback: handleLoopComplete,
            },
          ]}
        />
      </Container>
    </div>
  );
};

export default RadioButtonSelect;
